(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("businessDayUtils", BusinessDayUtils);

    BusinessDayUtils.$inject = ['TeamScheduleService'];

    function BusinessDayUtils (TeamScheduleService) {

        var self = this;

        var MINUTES = 60 * 1000;
        var HOURS = 60 * MINUTES;
        var DAY = 24 * HOURS;

        self.normalizeTimeIntervals = function (intervals, openTime) {
            var convertedIntervals = [];

            var lastProcessedInterval;

            for (var i in intervals) {
                var interval = intervals[i];

                if (interval.start_time && interval.end_time) {
                    var referencePoint = lastProcessedInterval? (lastProcessedInterval.end_time + 1): openTime;
                    var startTimeDate = moment(interval.start_time);
                    var startTime = startTimeDate.hours() * HOURS + startTimeDate.minutes() * MINUTES;

                    var endTimeDate = moment(interval.end_time);
                    var endTime = endTimeDate.hours() * HOURS + endTimeDate.minutes() * MINUTES;

                    if (startTime < referencePoint) {
                        startTime += DAY;

                        if (startTime < referencePoint) {
                            startTime += DAY;
                        }
                    }

                    if (endTime <= referencePoint) {
                        endTime += DAY;

                        if (endTime <= referencePoint) {
                            endTime += DAY;
                        }
                    }

                    if (endTime <= startTime) {
                        endTime += DAY;

                        if (endTime <= startTime) {
                            endTime += DAY;
                        }
                    }

                    lastProcessedInterval = {
                        start_time: startTime,
                        end_time: endTime
                    };

                    convertedIntervals.push(lastProcessedInterval);
                }
                else {
                    console.error("Interval ignored, should have 'start_time' and 'end_time':", interval);
                }
            }

            return convertedIntervals;
        };

        var checkIntervalBusinessDayIntersection = function (businessDay, timeIntervals, date, normalizedInterval, checkStartTimeOnly) {

            if (typeof (timeIntervals) === 'object' && !angular.isArray(timeIntervals)) {
                timeIntervals = [timeIntervals];
            }

            if (timeIntervals.length === 0) {
                console.error("Intervals are empty, considered not in business day");
                return {};
            }

            var result = {};
            var closeTimeExtension = businessDay['close_time_extension'];

            var openTime = businessDay.open_time;
            var closeTime = businessDay.close_time + closeTimeExtension;

            var intervals = normalizedInterval? timeIntervals: self.normalizeTimeIntervals(timeIntervals, openTime);

            var startOfStart = intervals[0].start_time;
            var endOfEnd = intervals[intervals.length - 1].end_time;

            if (checkStartTimeOnly) {
                result['within'] = startOfStart >= openTime;
            } else {
                result['within'] = (startOfStart >= openTime && endOfEnd <= closeTime && startOfStart < endOfEnd);
            }
            result['in_extension'] = (closeTimeExtension && endOfEnd > businessDay.close_time && endOfEnd <= closeTime);

            return result;
        };

        self.getActualBusinessDay = function (date) {
            var businessDay = TeamScheduleService.getBusinessDay(date);
            var originalBusinessDay = businessDay.business_day;
            var closeTimeWithExtension = businessDay.close_time + businessDay.close_time_extension;
            var openTime = businessDay.open_time;
            var businessDayLength = (closeTimeWithExtension - openTime) / 3600 / 1000;

            if (businessDayLength >= 24) {
               return {
                   open_time: openTime - (30 * MINUTES),
                   close_time: businessDay.close_time,
                   close_time_extension: businessDay.close_time_extension + (30 * MINUTES)
               };
            } else {
                if (originalBusinessDay.close_time > originalBusinessDay.open_time) {
                    return {
                        open_time: 0,
                        close_time: DAY,
                        close_time_extension: businessDay.close_time_extension
                    };
                } else {
                    return {
                        open_time: closeTimeWithExtension - DAY,
                        close_time: businessDay.close_time,
                        close_time_extension: businessDay.close_time_extension
                    };
                }
            }
        };

        self.getBusinessDayIntersection = (timeIntervals, date, normalizedInterval, flexibleCloseTime, checkStartTimeOnly, businessDay) => {
            if (!businessDay) {
                businessDay = flexibleCloseTime ? self.getActualBusinessDay(date) : TeamScheduleService.getBusinessDay(date);
            }
            return checkIntervalBusinessDayIntersection(businessDay, timeIntervals, date, normalizedInterval, checkStartTimeOnly);
        }

        self.isWithinBusinessDay = function(timeIntervals, date, normalizedInterval, flexibleCloseTime, checkStartTimeOnly, businessDay) {
            if (!businessDay) {
                businessDay = flexibleCloseTime ? self.getActualBusinessDay(date) : TeamScheduleService.getBusinessDay(date);
            }
            return checkIntervalBusinessDayIntersection(businessDay, timeIntervals, date, normalizedInterval, checkStartTimeOnly)['within'];
        };

        self.isInBusinessDayExtension = function (timeIntervals, date, normalizedInterval, flexibleCloseTime, checkStartTimeOnly) {
            var businessDay = flexibleCloseTime ? self.getActualBusinessDay(date) : TeamScheduleService.getBusinessDay(date);
            return checkIntervalBusinessDayIntersection(businessDay, timeIntervals, date, normalizedInterval, checkStartTimeOnly)['in_extension'];
        };

        self.isTimeInBusinessDayExtension = (firstTime, secondTime, date, checkSecondTime, referenceTime) => {
            const businessDay = TeamScheduleService.getBusinessDay(date);
            const closeTimeExtension = businessDay['close_time_extension'];
            const openTime = businessDay.open_time;
            const closeTime = businessDay.close_time;
            const closeTimeWithExtension = closeTime + closeTimeExtension;
            let referenceTimeInMilliseconds = referenceTime?.hours() * HOURS + referenceTime?.minutes() * MINUTES;

            if (referenceTime && referenceTimeInMilliseconds < openTime) {
                referenceTimeInMilliseconds += DAY;
            }

            const intervals = self.normalizeTimeIntervals(
                [{start_time: firstTime, end_time: secondTime}],
                referenceTime? referenceTimeInMilliseconds: openTime
            );

            let startOfStart = intervals[0].start_time;
            let endOfEnd = intervals[intervals.length - 1].end_time;
            let timeToCompare = checkSecondTime? endOfEnd: startOfStart;

            return (timeToCompare > closeTime && timeToCompare <= closeTimeWithExtension)
        };

        self.checkTimeZoneOffsetDifference = (clockIn, clockOut, timezoneName) => {
            const clockInOffset = moment.tz(moment(clockIn.slice(0, -1)).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;
            const clockOutOffset = moment.tz(moment(clockOut.slice(0, -1)).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;
            return clockOutOffset !== clockInOffset;
        };

        self.isBusinessDayClosed = (day, brand) => {
            const clockDateActualBusinessDay = self.getActualBusinessDay(day);
            const clockDateActualBusinessDayLimits = self.getBusinessDayLimits(clockDateActualBusinessDay, day);
            return Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).utcOffset(0, true).isAfter(clockDateActualBusinessDayLimits.closeTime.utcOffset(0, true))
        }

        self.getBusinessDayLimits = function (businessDay, day) {
            var openTime;
            var closeTime;
            var closeTimeWithoutExtension;
            if (day) {
                var dayTime = moment(day);
                openTime = dayTime.clone();
                closeTime = dayTime.clone();
                closeTimeWithoutExtension = dayTime.clone();
            } else {
                openTime = moment();
                closeTime = moment();
                closeTimeWithoutExtension = moment();
            }

            var extension = businessDay.close_time_extension / 1000;

            var openTimeSeconds = businessDay.open_time / 1000;

            openTime.hours(parseInt((openTimeSeconds) / 3600));
            openTime.minutes(parseInt(((openTimeSeconds) % 3600) / 60));

            var closeTimeSeconds = businessDay.close_time / 1000;

            closeTime.hours(parseInt((closeTimeSeconds + extension) / 3600));
            closeTime.minutes(parseInt(((closeTimeSeconds + extension) % 3600) / 60));

            closeTimeWithoutExtension.hours(parseInt((closeTimeSeconds) / 3600));
            closeTimeWithoutExtension.minutes(parseInt(((closeTimeSeconds) % 3600) / 60));

            return {
                closeTime: closeTime,
                openTime: openTime,
                closeTimeWithoutExtension: closeTimeWithoutExtension
            };
        };
    }
})();